<template>
  <div id="print-report">
    <div class="content">
      <div class="header-table">
        <div class="header-in-table">{{ $t('유해·위험 기계·기구 설비 현황') }}</div>
      </div>
      <div class="content-table">
        <table>
          <tbody>
          <tr>
            <th>{{ $t('대상년도') }}</th>
            <td>{{ targetYear || '-' }}년</td>
            <th>{{ $t('표시된 개수') }}</th>
            <td>총 {{ tableData.length || 0}}대</td>
          </tr>
          </tbody>
        </table>

        <table>
          <thead>
          <tr>
            <th>{{ $t('회사명') }}</th>
            <th>{{ $t('공정명') }}</th>
            <th>{{ $t('공정내용') }}</th>
            <th>{{ $t('위험 기계·기구·설비') }}</th>
            <th>{{ $t('재해형태') }}</th>
            <th>{{ $t('등록일') }}</th>
            <th>{{ $t('만료일') }}</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in tableData" :key="index" style="page-break-inside: avoid;">
              <td>{{ data['회사명'] }}</td>
              <td>{{ data['공정명'] }}</td>
              <td>{{ data['공정내용'] }}</td>
              <td>{{ data['위험기계기구설비'] }}</td>
              <td>{{ data['재해형태'] }}</td>
              <td>{{ data['등록일'] }}</td>
              <td>{{ data['만료일'] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
export default {
  name: "Print688",
  components: {PhotoUploadGridModule, TableInspectMerge},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    targetYear: {
      type: String,
      default: "",
    },
  },
  computed: {
    getTitles() {
      if (!this.form.inspectList) {
        return [];
      }
      return this.form.inspectList.map((item) => item.title);
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header-in-table {
  font-size: 32px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  padding: 36px 0;
  margin-bottom: 32px;
}

.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #757575;
          border-top: 1px solid #757575;
          border-right: 1px solid #757575;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #757575;
          border-top: 1px solid #757575;
          border-right: 1px solid #757575;
        }
      }
    }
  }
  .content-table {
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 14px;

      th,
      td {
        border: 1px solid #757575;
        text-align: center;
        min-height: 45px;
        height: 45px;
        font-size: 10px;
      }
      th {
        background-color: #ececec;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
      }
    }
  }

  .th-background {
    background-color: #ececec;
    white-space: nowrap;
  }
}
</style>
